/**
 * @title account-details.js: Sub-module for Account pages
 * @description This module is used to handle account details tasks
 * @dependency
 */
define(['membershipHelper', 'memberVerification', 'secureKeyMemberVerification', 'linkMembership', 'checkout_helper'], function(membershipHelper, memberVerification, secureKeyMemberVerification, linkMembership, checkoutHelper) {
  let AccountDetails = {
    /**
     * Basic initial function. Sets the membership data and fires the
     * needed validation methods.
     * @return {void}
     */
    init: function() {
      // membershipData sourced from AccountDetails_Data.jsp
      this.membershipData = membershipData;         
      COSTCO.util.maskMembershipInput();
      
      this.isVerified = this.membershipData && this.membershipData.verified;
      this.usage = this.membershipData && this.membershipData.caller.usage;
      this.usageRole = this.membershipData && this.membershipData.caller.usageRole;
      this.isEmployee = this.usage == 'Z030' && this.usageRole != '03';
      this.validationRules();
      membershipHelper.formWizBangs($('#household-form-details'));
      membershipHelper.addValidationMethods($('#household-form-details'));
      this.signInFormHandler();
      // this.membershipFormHandler();
      this.linkedMembershipFormHandler();
      this.determinePersonalInfoHandler();
      // this.personalInfoFormHandler();
      this.accountManagerFormHandler();
      this.householdFormHandler();
      this.employeeAddOnFormHandler();
      memberVerification.init();
      secureKeyMemberVerification.init();
      membershipHelper.formWizBangs($('#employee-addon-form'));
      this.setDob();
      
      if(sessionStorage.getItem('from_page') == 'costco_wallet'){
          COSTCO.AccountDetails.memberVerification();
          sessionStorage.removeItem('from_page');
        }
      
      // this.initPrimaryMembershipInfoForm();
      $('.co-help').popover();

      if(isDmcPage) {
	      if (dmcDoVerification) {
	    	  if (COSTCO.dialog.isVisible()) {
	    		  $('#costcoModal').hide();
	    	  }
	    	  COSTCO.AccountDetails.memberVerification();
	    	  
		  } else if(dmcRenewalFlow) {
			  if (COSTCO.dialog.isVisible()) {
	    		  $('#costcoModal').hide();
	    	  }
			  let primary_button = $(":input.primary.renew-button")[1];
			  primary_button.click();
		  }
      }
      
      // populate selectedMenuItem in session storage nav bar react component Account Details option to be highlighted
      if(window.location.href.includes("AccountInformationView") || window.location.href.includes("AccountDetailsView")){
    	  COSTCO.Global.updateSelectedMenuItem("AccountDetails.label");
      }
      
      console.log('Account Details sub-module initialized.');
    },
    /**
     * initPrimaryMembershipInfoForm is a function that is hooked into our
     * modular ajax framework and is meant to update sections of the form. However,
     * when we have multiple fields that are missing that are required, we need
     * a way to update all of the required fields in relation to the backend command
     * (MemberPrimaryInformationUpdateCmdImpl)
     * @return {void}
     */
    determinePersonalInfoHandler: function() {
      // We'll use the data attribute field-protection on each form element
      // to determine if we have a missing required input. If so, we'll use the
      // traditional handler to send the entire form to the backend.
      membershipHelper.formWizBangs($('#primary-information-update'));
      AccountDetails.setState();
      if(costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true"){
        AccountDetails.setCity();
      }
      if (this.anyRequiredFieldsMissing()) {
        this.personalInfoFormHandler();
      } else {
        this.bindPrimaryInformationEvents();
      }
    },
    /**
     * Are any form elements with field-protection with EDITABLE_REQUIRED value
     * missing a value?
     * @return {boolean} The answer
     */
    anyRequiredFieldsMissing: function() {
      let answer = false;
      $('#primary-information-update [data-field-protection]').each(function(index, el) {
    	let fieldProtection = $(el).data('field-protection');
    	if (fieldProtection === 'EDITABLE_REQUIRED' && !($(el).val() || $(el).attr('data-selected'))) {
          answer = true;
        }
      });
      return answer;
    },
    /**
     * Gets jquery primary memebership information form
     * @return {jqueryForm} form
     */
    getPrimaryMembershipInfoForm: function() {
      return $('#primary-information-update');
    },
    /**
     * Binds specific events on the primary membership information form buttons, so that we can submit form sections independantly.
     */
    bindPrimaryInformationEvents: function() {
      $('#update-primary-nickname-btn').off().on('click', function() {
        let data = AccountDetails.preparePrimaryNicknameData();
        AccountDetails.ajaxUpdatePrimaryInformation(data);
      });
      $('#update-primary-address-btn').off().on('click', function(event) {
        AccountDetails.validateFields(sendAddressData);
        /**
         * [sendAddressData description]
         * @return {void}
         */
        function sendAddressData() {
          if (AccountDetails.needsVerification()) {
            membershipHelper
              // Execute address verification on the primary information address.
              .verifyAddresses({
                form: '#primary-information-update',
                primary: membershipHelper.primaryInformationSelectors,
              })
              // Invoke the address verification modal
              .then((verifyResponse) => membershipHelper.invokeMultiAVS(verifyResponse, function(addresses) {
                let data = AccountDetails.preparePrimaryAddressData(addresses);
                AccountDetails.ajaxUpdatePrimaryInformation(data);
              })).fail(AccountDetails.failHandler);
          } else {
            let data = AccountDetails.preparePrimaryAddressData();
            AccountDetails.ajaxUpdatePrimaryInformation(data);
          }
        }
      });
      $('#update-primary-phone-btn').on('click', function() {
        AccountDetails.validateFields(sendPhoneData, 'phoneNum', $('#update-phone'));
        /**
         * [sendPhoneData description]
         * @return {void} [description]
         */
        function sendPhoneData() {
          let data = AccountDetails.preparePrimaryPhoneData();
          AccountDetails.ajaxUpdatePrimaryInformation(data);
        }
      });
      $('#update-primary-mobile-phone-btn').on('click', function() {
        AccountDetails.validateFields(sendMobilePhoneData, 'mobilePhoneNum', $('#update-mobile'));
        /**
         * [sendMobilePhoneData description]
         * @return {void}
         */
        function sendMobilePhoneData() {
          let data = AccountDetails.preparePrimaryMobilePhoneData();
          AccountDetails.ajaxUpdatePrimaryInformation(data);
        }
      });
      $('#update-primary-email-btn').on('click', function() {
        AccountDetails.validateFields(sendEmailData, 'email_rule', $('#update-membership-email'));
        /**
         * [sendEmailData description]
         * @return {void}
         */
        function sendEmailData() {
          let data = AccountDetails.preparePrimaryEmailData();
          AccountDetails.ajaxUpdatePrimaryInformation(data);
        }
      });
      $('#update-dob-btn').off().on('click', function() {
    	  /** DOB fields such as Year, Month and Day validation, Error display and form submission */
    	  let valid = false;
    	  membershipHelper.addValidationMethods($('#primary-information-update'));
          let rules = null;
          let messages = null;
          if (membershipHelper.isBusinessMembership()) {
        	  rules = membershipHelper.business.rules;
        	  messages = membershipHelper.business.messages();
          } else {
        	  rules = membershipHelper.goldstar.rules;
        	  messages = membershipHelper.goldstar.messages();
          }
          if (rules && messages) {
        	  $('#primary-information-update').validate({
        		  invalidHandler: COSTCO.util.invalid_handler,
        		  rules: rules,
        		  messages: messages,
        	  });
        	  valid = $('#primary-information-update').valid();
          }
          
          if(valid) {
        	  let data = AccountDetails.preparePrimaryDobData();
        	  AccountDetails.ajaxUpdatePrimaryInformation(data);  
          }
    	  
      });      
    },
    forms: {
      getPrimaryInformationForm: function() {
        return $('#primary-information-update');
      },
    },
    /**
     * Makes the actual ajax modular request to update the primary membership information
     * @param  {JSONObj} data JSON data to be passed to backend
     */
    ajaxUpdatePrimaryInformation: function(data) {
      COSTCO.util.notification.clearNotification();
      COSTCO.Checkout.ajax_update_state({
        method: 'POST',
        url: '/AjaxMemberPrimaryInformationUpdateCmd',
        data: data,
        dataType: 'json',
        ajax_update_post_done: function(data) {
          if (data.error.application.length > 0) {
            COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application]);
            $('html, body').scrollToElem($('#notification-message'), 100);
          } else if (data.payload.data.status === 'success') {
            let dataJson = JSON.parse(data.payload.data.memberDataJson);
            AccountDetails.membershipData = dataJson;
            if (!AccountDetails.hasError(dataJson)) {
              COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.SUCCESS, [data.payload.data.message]);
              COSTCO.util.updateCappJson(dataJson.caller);
              COSTCO.util.processCappLogic();
              // AccountDetails.initPrimaryMembershipInfoForm();
              AccountDetails.determinePersonalInfoHandler();
            } else {
              $('html, body').scrollToElem($('#notification-message'), 100);
            }
          }
        },
      });
    },
    /**
     * Prepare JSON data obj with only primary nickname data from the primary
     * membership information form. Other data info is get from membershipData JSON.
     * @return {JSONObj} data JSON object to be passed to backend service
     */
    preparePrimaryNicknameData: function() {
      let data = AccountDetails.getDefaultPrimaryInfoObj();
      data.updateSection = 'nickname';
      data.MembershipCrmCallerInfo_nickname = AccountDetails.forms.getPrimaryInformationForm().find('input[name="MembershipCrmCallerInfo_nickname"]').val();
      return data;
    },
    /**
     * Prepare JSON data obj with only primary address data from the primary
     * membership information form. Other data info is get from membershipData JSON.
     * @param  {Array} avsAddresses An array of AVS addresses in JSON format,
     *  If passed as a parameter, take presedance of the address details returned by the AVS
     * @return {JSONObj} data JSON object to be passed to backend service
     */
    preparePrimaryAddressData: function(avsAddresses) {
      let data = AccountDetails.getDefaultPrimaryInfoObj();
      let $form = AccountDetails.forms.getPrimaryInformationForm();
      // Common data
      data.updateSection = 'address';
      data.MembershipCrmCallerInfo_urbanizationName = $form.find('input[name="MembershipCrmCallerInfo_urbanizationName"]').val();
      if (avsAddresses && avsAddresses.length > 0) { // If AVS obj is passed get address details from it
        let addressObj = avsAddresses[0];
        data.MembershipCrmCallerInfo_addressLine1 = addressObj.line1;
        data.MembershipCrmCallerInfo_addressLine2 = addressObj.line2;
        data.MembershipCrmCallerInfo_city = addressObj.city;
        data.MembershipCrmCallerInfo_stateDropDown_country = addressObj.country;
        data.MembershipCrmCallerInfo_stateDropDown_state = addressObj.state;
        data.MembershipCrmCallerInfo_zipCode = addressObj.zip;
      } else {
        data.MembershipCrmCallerInfo_addressLine1 = $form.find('input[name="MembershipCrmCallerInfo_addressLine1"]').val();
        data.MembershipCrmCallerInfo_addressLine2 = $form.find('input[name="MembershipCrmCallerInfo_addressLine2"]').val();
        data.MembershipCrmCallerInfo_zipCode = $form.find('input[name="MembershipCrmCallerInfo_zipCode"]').val();
        data.MembershipCrmCallerInfo_city = $form.find('select[name="MembershipCrmCallerInfo_city"]').length ? 
        		$form.find('#update-city').find(':selected').val() : $form.find('input[name="MembershipCrmCallerInfo_city"]').val();
        data.MembershipCrmCallerInfo_stateDropDown_state = $form.find('#update-state').find(':selected').val();
        data.MembershipCrmCallerInfo_stateDropDown_country = $form.find('input[name="MembershipCrmCallerInfo_stateDropDown_country"]').val();
      }
      return data;
    },
    /**
     * Prepare JSON data obj with only primary phone data from the primary
     * membership information form. Other data info is get from membershipData JSON.
     * @return {JSONObj} data JSON object to be passed to backend service
     */
    preparePrimaryPhoneData: function() {
      let data = AccountDetails.getDefaultPrimaryInfoObj();
      data.updateSection = 'phone';
      data.MembershipCrmCallerInfo_phone = AccountDetails.forms.getPrimaryInformationForm().find('input[name="MembershipCrmCallerInfo_phone"]').val();
      return data;
    },
    /**
     * Prepare JSON data obj with only primary mobile phone data from the
     * primary membership information form. Other data info is get from membershipData JSON.
     * @return {JSONObj} data JSON object to be passed to backend service
     */
    preparePrimaryMobilePhoneData: function() {
      let data = AccountDetails.getDefaultPrimaryInfoObj();
      data.updateSection = 'mobilePhone';
      data.MembershipCrmCallerInfo_mobile = AccountDetails.forms.getPrimaryInformationForm().find('input[name="MembershipCrmCallerInfo_mobile"]').val();
      return data;
    },
    /**
     * Prepare JSON data obj with only primary email data from the
     * primary membership information form. Other data info is get from membershipData JSON.
     * @return {JSONObj} data JSON object to be passed to backend service
     */
    preparePrimaryEmailData: function() {
      let data = AccountDetails.getDefaultPrimaryInfoObj();
      data.updateSection = 'email';
      data.MembershipCrmCallerInfo_email = AccountDetails.forms.getPrimaryInformationForm().find('input[name="MembershipCrmCallerInfo_email"]').val();
      return data;
    },
    /**
     * Prepare JSON data obj with only dob data from the primary membership
     * information form. Other data info is get from membershipData JSON.
     * @return {JSONObj} data JSON object to be passed to backend service
     */
    preparePrimaryDobData: function() {
      let data = AccountDetails.getDefaultPrimaryInfoObj();
      data.updateSection = 'dob';
      data.MembershipCrmCallerInfo_dobEditMonth = AccountDetails.forms.getPrimaryInformationForm().find('[name=MembershipCrmCallerInfo_dobEditMonth]').val();
      data.MembershipCrmCallerInfo_dobEditDay = AccountDetails.forms.getPrimaryInformationForm().find('[name=MembershipCrmCallerInfo_dobEditDay]').val();
      data.MembershipCrmCallerInfo_dobEditYear = AccountDetails.forms.getPrimaryInformationForm().find('[name=MembershipCrmCallerInfo_dobEditYear]').val();
      return data;
    },
    /*
     * Creates JSON primary information data object from caller
     * @return {JSON} JSON primary information data object
     */
    getDefaultPrimaryInfoObj: function() {
      let c = this.membershipData.caller;
      let data = {};
      data.authToken = COSTCO.Checkout.getAuthToken();
      data.MembershipCrmCallerInfo_nickname = c.nickname.value;
      data.MembershipCrmCallerInfo_addressLine1 = c.addressLine1.value;
      data.MembershipCrmCallerInfo_addressLine2 = c.addressLine2.value;
      data.MembershipCrmCallerInfo_zipCode = c.zip.value;
      data.MembershipCrmCallerInfo_city = c.city.value;
      data.MembershipCrmCallerInfo_stateDropDown_state = c.state.value;
      data.MembershipCrmCallerInfo_stateDropDown_country = c.country.value;
      data.MembershipCrmCallerInfo_urbanizationName = c.urbanizationName.value;
      data.MembershipCrmCallerInfo_phone = c.homePhone.field1.value + c.homePhone.field2.value + c.homePhone.field3.value;
      data.MembershipCrmCallerInfo_mobile = c.mobile.field1.value + c.mobile.field2.value + c.mobile.field3.value;
      data.MembershipCrmCallerInfo_email = c.email.value;
      return data;
    },
    /**
     * Validates a single input if passed to function,
     * or ALL validate-able inputs validate_inputs object.
     * @param  {Function} callback The function to be called after successful validation.
     * @param  {string}   rule     OPTIONAL: The specific rule to validate if we're dealing with just one input
     * @param  {string}   $input   OPTIONAL: Input field for validation against rule provided
     * @return {void}
     */
    validateFields: function(callback, rule, $input) {
      let $form = AccountDetails.forms.getPrimaryInformationForm();
      let validateInputs = AccountDetails.attachRulesToInputFields;
      let rulesConfigObj = AccountDetails.inputRules();
      COSTCO.Checkout._dynamic_validate({
        input: $input,
        rule: rule,
        form: $form,
        validate_inputs: validateInputs,
        rules_config_obj: rulesConfigObj,
        callback: callback,
      });
    },
    /**
     * Attaches rules to address input fields
     * @return {void}
     */
    attachRulesToInputFields: function() {
      $('#update-line1').rules('add', AccountDetails.inputRules().addressLine1);
      $('#update-line2').rules('add', AccountDetails.inputRules().addressLine2);
      $('#update-city').rules('add', AccountDetails.inputRules().city);
      $('#update-state').rules('add', AccountDetails.inputRules().stateDropDown_state);
      $('#update-zip').rules('add', AccountDetails.inputRules().zipCode);
    },
    /**
     * Defines rules object for input fields/form validation
     * @return {void}
     */
    inputRules: function() {
      let rules = {};
      rules.email_rule = {
        required: true,
        singleemail: true,
        messages: {
          required: messages.ERR_REQUIRED_EMAIL,
          singleemail: messages.ERR_INVALID_EMAIL_ADDRESS,
        },
      };
      rules.addressLine1 = {
        maxlength: 30,
        required: true,
        valid_address: true,
        messages: {
          maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
          required: messages.ERR_INVALID_STREET_REQUIRED,
          valid_address: messages.ERR_INVALID_ADDRESS,
        },
      };
      rules.addressLine2 = {
        maxlength: 30,
        valid_address: true,
        messages: {
          maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
          valid_address: messages.ERR_INVALID_ADDRESS,
        },
      };
      rules.zipCode = {
        required: true,
        postalCode: true,
        minlength: 5,
        messages: {
          required: messages.ERR_ENTER_ZIPCODE_NEW,
          postalCode: messages.ERR_ENTER_ZIPCODE,
          minlength: messages.ERR_VALID_ZIPCODE,
        },
      };
      rules.city = {
        required: true,
        valid_cityState: true,
        messages: {
          required: messages.ERR_INVALID_CITY_REQUIRED,
          valid_cityState: messages.ERR_INVALID_CITY_NAME,
        },
      };
      rules.stateDropDown_state = {
        required: true,
        notEqual: 'NO_STATE_TYPE_SELECTED',
        valid_cityState: true,
        messages: {
          required: messages.ERR_INVALID_STATE_NAME,
          notEqual: messages.ERR_INVALID_STATE_NAME,
          valid_cityState: messages.ERR_INVALID_STATE_NAME,
        },
      };
      rules.phoneNum = {
        phone: true,
        required: true,
        messages: {
          phone: messages.ERR_INVALID_PHONE_10_DIGIT,
          required: messages.ERR_INVALID_PHONE_10_DIGIT,
        },
      };
      rules.mobilePhoneNum = {
        phone: true,
        messages: {
          phone: messages.ERR_INVALID_PHONE_10_DIGIT,
        },
      };
      rules.month = {
        required: false,
        dob: true,
      };
      rules.day = {
        required: false,
        dob: true,
      };
      rules.year = {
        required: false,
        dob: true,
      };
      return rules;
    },
    /**
     * If the user has a date of birth, set it using the data attributes
     * attached to each select representing the month, day, year.
     * @return {void}
     */
    setDob: function() {
      let $month = $('select[name=MembershipCrmCallerInfo_dobEditMonth]');
      let $day = $('select[name=MembershipCrmCallerInfo_dobEditDay]');
      let $year = $('select[name=MembershipCrmCallerInfo_dobEditYear]');
      $month.data('month') !== '' ? $month.val(parseInt($month.data('month'), 10)) : void 0;
      $day.data('day') !== '' ? $day.val(parseInt($day.data('day'), 10)) : void 0;
      $year.data('year') !== '' ? $year.val(parseInt($year.data('year'), 10)) : void 0;
      // Case where the select is readonly, we just want the selected option enabled.
      $month.add($day).add($year).find('option:selected').removeAttr('disabled');
    },
    /**
     * The onclick handler for the "Renew Now" button when the user doesn't
     * have executive tier.
     * @return {void}
     */
    upsellModalRenew: function(memberType) {
      
      let doNotCloseModalFlag = false;
      if(isDmcPage){
  	    doNotCloseModalFlag = true;
      }
    	
      COSTCO.dialog.modalStack({
        title: messages.RENEW_UPGRADE_UPSELL__Membership_Renewal,
        body: COSTCO.util.tmpl('tmpl_upgrade_membership', {}),
        preventClose: doNotCloseModalFlag,
        primary: messages.RENEW_UPGRADE__Upgrade,
    	primary_event: () => {
    		COSTCO.dialog.close();
    		COSTCO.MembershipValidation.renewMembership(memberType, false, true);
        },
        secondary: messages.RENEW_UPGRADE__NO,
        secondary_event: () => {
    		COSTCO.MembershipValidation.renewMembership(memberType, false, false);
        },
        close: () => {
          if(isDmcPage) {
	       	COSTCO.MemberVerification.proceedeToDMCCheck('renewal', true);
	      }
          else {
        	COSTCO.dialog.close();
          }
        },
      });
    },
    /**
     * For the user's address in the membership information, this function sets
     * the state value asscoiated with the CRM caller.state value. You can see
     * it with this.membershipData.
     * @param  {string} state The two letter state "WA", "OR", etc.
     * @return {void}
     */
    setState: function(state) {
      $('#update-state').val(state || $('#update-state').data('selected'));
      // Case where the select is readonly, we just want the selected option enabled.
      $('#update-state').find('option:selected').removeAttr('disabled');
    },
    /**
     * For the user's address in the membership information, this function sets
     * the city value associated with the CRM caller.city value. You can see
     * it with this.membershipData.
     * @param  {string} city
     * @return {void}
     */
    setCity: function(city) {
      $('#update-city').val(city || $('#update-city').data('selected'));
      // Case where the select is readonly, we just want the selected option enabled.
      $('#update-city').find('option:selected').removeAttr('disabled');
    },
    /**
     * Is the CRM country = US?
     * @return {boolean}
     */
    isUS: function() {
      return $('[name=MembershipCrmCallerInfo_stateDropDown_country]').val() === 'US';
    },
    /**
     * The validation rules for the inputs on Account Details
     * @return {void}
     */
    validationRules: function() {
      // This is the only unique rule not in membership-helper.js.addValidationMethods
      $.validator.addMethod('postalCode', function(value, element) {
        return !COSTCO.AccountDetails.isUS() ? this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_CA.test($.trim(value)) : this.optional(element) || COSTCO.util.POSTAL_CODE_REGEX_US.test($.trim(value));
      }, messages.ERR_ENTER_ZIPCODE);
    },
    /**
     * The onclick handler for the Sign In Information section on Account
     * Details. Switches to the editable form that the user uses to update
     * their email.
     * @return {void}
     */
    editEmail: function() {
      $('#sign-in-verbiage').hide();
      $('#edit-email, #email-value-container').addClass('hide');
      $('#email-update-container').removeClass('hide');
      $('#update-email').focus();
    },
    /**
     * The onclick handler for the Membership Information section on Account
     * Details. Displays the form#membership-number-form for submission
     * @return {void}
     */
    editMembership: function() {
      $('#edit-membership, #membership-number-value-container').addClass('hide');
      $('#membership-update-container').removeClass('hide');
      $('#update-membership').focus();
    },

    editLinkedMembership: function() {
      let bypassEnabled = typeof memberValidationBypassFeatureEnabled !== "undefined" && memberValidationBypassFeatureEnabled === true;
      if(bypassEnabled){
        $('[for=update-linked-membership]').addClass('hide');
      }
      $('#edit-linked-membership, #linked-membership-number-value-container')
        .addClass('hide');
      $('#linked-membership-update-container').removeClass('hide');
      $('label[for=update-linked-membership]').removeClass('margin-bottom-0');
      $('#update-linked-membership').focus();
    },
    /**
     * The onclick handler for the Membership Information section. The personal
     * information fields like address, phone number, etc.
     * @return {void}
     */
    editInfo: function() {
      $('#language-verbiage').hide();
      $(this).addClass('hide'); // hide yoself
      $($(this).data('hide')).addClass('hide');
      $($(this).data('show')).removeClass('hide');
      $($(this).data('input')).focus();
      if($(this).attr('id') === 'edit-address'){
      	if(costcoStoreFeatures.DERIVE_CITY_STATE_FROM_ZIP_POSTAL_CODE_ENABLED && $('input[name=deriveCityStateEnabled]') && $('input[name=deriveCityStateEnabled]').val() === "true"){
            AccountDetails.setCityStateForEdit();
        } else {
      	  $('#city-state').removeClass('hide');
        }
      }
    },
    /**
     * The function to make the geocodeAPI call for the zip code and populate the city and state fields
     * @return {void}
     */
    setCityStateForEdit: function() {
    	 var zipSelector = '#update-zip';
         var isBusinessInfo = $(zipSelector).attr('name') === 'MembershipCrmBusiness_zipCode';
         var savedAddrCity = isBusinessInfo ? $('#business-city').text() : $('#membership-city').text();
         var savedAddrState = isBusinessInfo ? $('#business-state').text() : $('#membership-state').text();
         var cityQuery = isBusinessInfo ? '[name=MembershipCrmBusiness_city]' : '[name=MembershipCrmCallerInfo_city]';
         var stateQuery = isBusinessInfo ? '[name=MembershipCrmBusiness_stateDropDown_state]' : '[name=MembershipCrmCallerInfo_stateDropDown_state]';
         if(savedAddrCity && savedAddrState){
           COSTCO.CAddress.geocodeApiCityState(zipSelector,cityQuery,stateQuery, savedAddrCity, savedAddrState);
         }
    },
    /**
     * The onclick handler for the "Add Account Manager" button. Shows the
     * editable fields.
     * @return {void}
     */
    addAccountManager: function() {
      $(this).addClass('hide');
      $(this.form).find('.am-editable-fields').removeClass('hide');
      $(this.form).find('[name=member_firstname]').focus();
    },
    /**
     * The onclick handler for the Household "Add Person" button. Shows the
     * editable fields.
     * @return {void}
     */
    addHousehold: function() {
      let $container = $(this).parents('.household-container');
      let $verbiage = $container.next();
      // This is necessary because of the nature of the design.
      $container.removeClass('col-lg-4').addClass('col-lg-8');
      $verbiage.removeClass('col-lg-offset-4');
      $(this).addClass('hide');
      $(this.form).find('.household-fields').removeClass('hide');
    },
    /**
     * The onclick handler for the Employee Add On "Add Person" button.
     * Shows the editable fields. users.field2 must be a employee membership no.
     * @return {void}
     */
    employeeAddOn: function() {
      let $container = $(this).parents('.employee-addon-container');
      let $verbiage = $container.next();
      // This is necessary because of the nature of the design.
      $container.removeClass('col-lg-4').addClass('col-lg-8');
      $verbiage.removeClass('col-lg-offset-4');
      $(this).addClass('hide');
      $(this.form).find('.employeeAddOn-fields').removeClass('hide');
    },
    /**
     * This is the form handler for the Sign In Information form (
     * form#sign-in-form).
     * @return {void}
     */
    signInFormHandler: function() {
      $('#sign-in-form').validate({
        rules: {
          MembershipSignInInformation_formEmail: {
            singleemail: true,
            required: true,
            maxlength: 251
          },
        },
        messages: {
          MembershipSignInInformation_formEmail: {
            singleemail: messages.ERR_REQUIRED_EMAIL,
            required: messages.ERR_REQUIRED_EMAIL,
            maxlength: messages.ERR_EMAIL_MAX_LENGTH
          },
        },
        submitHandler: function(form) {
          let formData = AccountDetails.getData(form);
          formData.push({
            name: 'invalidate',
            value: membershipHelper.isInternalInvalidated(form),
          });
          COSTCO.util.ajax({
            url: '/UserRegistrationUpdateAjaxCmd',
            type: 'POST',
            data: formData,
          }).done(COSTCO.util.safe(function(response, textStatus, jqXHR) {
            let data = JSON.parse(response);
            if (!AccountDetails.hasError(data)) {
              if (location.search.includes('PharmacyManagePatientProfileCmd')) {
                // Redirect to pharmacy
                window.location.href = 'Pharmacy/patient-profile?selectedTab=account_and_patient_info&SuccessMessageKey=true';
              } else {
                data.genericMessage = true;
                AccountDetails.successHandler(data);
              }
            }
          }), 'COSTCO.AccountDetails.signInFormHandler').fail(AccountDetails.failHandler);
        },
      });
    },
    /**
     * This is the form handler for the Membership Number form (
     * form#membership-number-form).
     * @return {void}
     * @deprecated - Using linked membership form handler
     */
    membershipFormHandler: function() {
      $('#membership-number-form').validate({
        rules: {
          membershipNumber: {
            // Accommodate users that have pre-existing long numbers?
            minlength: this.isVerified ? 8 : 12,
            maxlength: this.isVerified ? 25 : 16,
            digits: true,
          },
        },
        messages: {
          membershipNumber: {
            minlength: messages.ERR_INVALID_MEMBERSHIP_NO,
            maxlength: messages.ERR_INVALID_MEMBERSHIP_NO,
            digits: messages.ERR_INVALID_MEMBERSHIP_NO,
          },
        },
        submitHandler: (form) => {
          this.updateMembershipNumber();
        },
      });
    },
    /**
     * [description]
     * @return {void}
     */
    linkedMembershipFormHandler: function() {
      $('#linked-membership-number-form').validate({
        rules: {
          membershipId: {
            // Accommodate users that have pre-existing long numbers?
        	required: true,
            minlength: this.isVerified ? 8 : 12,
            maxlength: this.isVerified ? 25 : 16,
            digits: true,
          },
          lastName: {
            required: {
              depends: function(element) {
            	  if($("[name='linkMembershipOnlyButton']")[0] !== undefined) {
            	    $("[name='linkMembershipOnlyButton']")[0].disabled = false;  
            	  }
                return $('#membershipId') !== undefined  && $('#membershipId').val() !== '';
              },
            },
          },
        },
        messages: {
          membershipId: {
        	required: messages.ERR_INVALID_MEMBERSHIP_NO,
            minlength: messages.ERR_INVALID_MEMBERSHIP_NO,
            maxlength: messages.ERR_INVALID_MEMBERSHIP_NO,
            digits: messages.ERR_INVALID_MEMBERSHIP_NO,
          },
          lastName: {
            required: messages.ERR_INVALID_LASTNAME,
          },
        },
        submitHandler: (form) => {
          let addMembershipButton = $("input[automation-id='addMembershipButton");
          if (typeof(addMembershipButton) != 'undefined' && addMembershipButton != null) {
        	  addMembershipButton.attr("data-bi-tc", "ui:Account Details | Add Membership Number Only");
          }
        
          this.clearErrors();
          if (($(form).find('#membershipId').val() === '' && 
            ($(form).find('#lastName').val() === '' || typeof $(form).find("#lastName").val() === "undefined"))) {
            this.updateMembershipNumber();
          } else {
        	  if ((typeof verifyMeFlowEnabled !== 'undefined' && verifyMeFlowEnabled === true  && wcs.storeId !== 'undefined' && wcs.storeId === '10302')
      	    		&&  (!($.isNumeric($("#membershipNumber").val()) && $("#membershipNumber").val().length === 12))) {
      	    	   // verify me flow enabled and CA and membership number is invalid	    	    
      	        	$("#membershipNumber").parent()[0].classList.add("mdc-text-field--invalid");
      	            $("#membershipNumber")[0].classList.add("highlightError");
      	            $("#membershipNumber").parent()[0].nextElementSibling.children[0].innerHTML= messages.ERR_INVALID_MEMBERSHIP_NO;
      	            $("#membershipNumber").parent()[0].nextElementSibling.style.display = 'block';
      	       }else{  
      	    	   this.primaryValidation(form);
      	       }	   
          }
        },
        invalidHandler: function(event, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
            	window.digitalDataEvents = window.digitalDataEvents || [];
            	digitalDataEvents.push( { uimsg:"Member Verification Flow | Enter Valid Membership Number Error" } )
            } 
          }
      });
    },
    
    validateMembershipNumber: function () {
    	const membershipNumber = $("#membershipNumber").val();
        isValid = false;                
        if (!($.isNumeric(membershipNumber) && membershipNumber.length === 12)) {
            $("#membershipNumber").parent()[0].classList.add("mdc-text-field--invalid");
            $("#membershipNumber")[0].classList.add("highlightError");
            $("#membershipNumber").parent()[0].nextElementSibling.children[0].innerHTML= messages.ERR_INVALID_MEMBERSHIP_NO;
            $("#membershipNumber").parent()[0].nextElementSibling.style.display = 'block';               
            isValid = false;
        }else {
            $("#membershipNumber").parent()[0].classList.remove("mdc-text-field--invalid");
            $("#membershipNumber")[0].classList.remove("highlightError");
            $("#membershipNumber").parent()[0].nextElementSibling.style.display = 'none';                
            isValid = true;
        }
        
        return isValid;
        
    },
    /**
     * Clears error notification box and removes validation-error class from input fields.
     */
    clearErrors: function() {
      COSTCO.util.notification.clearNotification('#form-error-placeholder');
      $('input.validation-error').removeClass('validation-error');
    },
    /**
     * This is a variant of LinkMembership.performPrimaryValidation. Where
     * that one invokes a modal, this one is inline.
     * @param  {[type]} form [description]
     * @return {[type]}      [description]
     */
    primaryValidation: function(form) {
      return COSTCO.util.ajax({
          method: 'POST',
          url: '/AjaxMembershipPrimaryValidationCmd',
          dataType: 'json',
          data: $(form).serializeArray(),
        })
        .done(COSTCO.util.safe(function(data, textStatus, jqXHR) {
          if (data.payload.data.status == 'success') {
        	sessionStorage.removeItem("changeValidationFlag");
        	sessionStorage.setItem('successUpdate', true);
            if (data.payload.data.validationCompleted) {
              COSTCO.dialog.close();           
              let url = window.location.href;  
              let secureKeySuccessParam = COSTCO.util.getParameterByName('secureKeySuccess',url);
              if( typeof secureKeySuccessParam !== 'undefined' && secureKeySuccessParam!== '' && secureKeySuccessParam === 'true') {
            	  url = COSTCO.util.removeParam("secureKeySuccess",url);
            	  window.location.href = url; 
              }else {
            	  location.reload();
              }            
            } else {
              COSTCO.AccountDetails.secondaryValidationModal(data, textStatus, jqXHR);
            }
          } else if (data.error.application.length > 0) {
        	if($("[name='linkMembershipOnlyButton']")[0] != undefined) {
        	  $("[name='linkMembershipOnlyButton']")[0].disabled = false;
        	}
            let errorCode = data.payload.data.errorCode;
            // Expired/canceled membership: exit function and redirect to appropriate page in Create Account flow.
            if (errorCode == 'E53') {
              COSTCO.dialog.close();
              if(data.payload.data.URL !== undefined){
            	  window.location.href = '/MembershipSecondaryValidationView?isReturningUser=true&URL='+encodeURIComponent(data.payload.data.URL);
              }else{
            	  window.location.href = '/MembershipSecondaryValidationView';
              }
              return;
            } else if (errorCode == 'E54') {
              let canceledMembershipNumber = data.payload.data.membershipId ? data.payload.data.membershipId : '';
              let membershipStatusReason = data.payload.data.membershipStatusReason ? data.payload.data.membershipStatusReason : '';
              let membership_membershipType = data.payload.data.membership_membershipType ? data.payload.data.membership_membershipType : '';
              let isLostOrStolenCard = data.payload.data.isLostOrStolenCard ? data.payload.data.isLostOrStolenCard : '';
              let url = data.payload.data.URL ? data.payload.data.URL : '';
              $form = $(`<form class="hide" action="${COSTCO.LinkMembership.constants.CANCELED_MEMBERSHIP_VIEW}"/>`);
              $form.append('<input type="hidden" name="canceledMembershipNumber" value="' + canceledMembershipNumber + '">');
              $form.append('<input type="hidden" name="membershipStatusReason" value="' + membershipStatusReason + '">');
              $form.append('<input type="hidden" name="membership_membershipType" value="' + membership_membershipType + '">');
              $form.append('<input type="hidden" name="isLostOrStolenCard" value="' + isLostOrStolenCard + '">');
              $form.append('<input type="hidden" name="isReturningUser" value="true">');
              $form.append('<input type="hidden" name="URL" value="'+ url +'">');
              $('body').append($form);
              $form.submit();
            } else {
              // Override this particular error message with the post-lockdown one; Remove as redundant in post-lockdown phase.
              if (data.payload.data.errorCode == 'E07') {
                data.error.application = [];
                data.error.application.push(messages._ERR_MEMBERSHIP_PRIMARY_VALIDATION_MEMBERSHIP_ID_POSTLOCKDOWN);
              }
              COSTCO.util.notification.displayNotification(
                COSTCO.util.notification.type.ERROR, data.error.application, false,
                '#form-error-placeholder');
              COSTCO.LinkMembership.markErrorFields(errorCode);
            }
          } else {
            COSTCO.util.notification.displayNotification(
              COSTCO.util.notification.type.ERROR, ['Unexpected error occurred.'], false,
              '#form-error-placeholder');
            console.error('Unexpected error occurred.');
          }
        }), 'COSTCO.AccountDetails.primaryValidation')
        .fail(AccountDetails.failHandler);
    },
    /**
     * [description]
     * @param  {[type]} data       [description]
     * @param  {[type]} textStatus [description]
     * @param  {[type]} jqXHR      [description]
     * @return {void}
     */
    secondaryValidationModal: function(data, textStatus, jqXHR) {
      COSTCO.dialog.modalStack({
        dialogclasses: 'link-membership-modal',
        title: messages.LINK_MEMBERSHIP_TITLE,
        body: COSTCO.util.tmpl('tmpl_membership_validation_empty', {}),
        primary: messages.LINK_MEMBERSHIP_BUTTON,
        secondary: messages.JS_DIALOG_CANCEL,
        primary_event: linkMembership.performSecondaryValidation,
        preventClose: false,
        onshown: function() {
          $('.modal-header, .modal-body, .modal-footer').addClass('order-ajax');
        },
        onclose: function() {
          if ($("input[name='linkMembershipOnlyButton']").length > 0 ){
            $("input[name='linkMembershipOnlyButton']").attr('disabled',false);
          }
        },
      });
      checkoutHelper.ajax_update_default_done(data, textStatus, jqXHR);
    },
    /**
     * This is the form handler for the Personal Information form (
     * form#primary-information-update).
     * @return {void}
     */
    personalInfoFormHandler: function() {
      // If we're here we want to make any of the buttons trigger validation.
      // Meaning we need to switch the type from button to submit.
      $('#primary-information-update input[type=button]').attr('type', 'submit');
      $('#primary-information-update').validate({
        ignore: 'not:hidden',
        rules: {
          MembershipCrmCallerInfo_addressLine1: {
            maxlength: 30,
            required: !this.isEmployee,
            valid_address: true,
          },
          MembershipCrmCallerInfo_addressLine2: {
            maxlength: 30,
            valid_address: true,
          },
          MembershipCrmCallerInfo_zipCode: {
            required: !this.isEmployee,
            postalCode: true,
            minlength: 5,
          },
          MembershipCrmCallerInfo_city: {
            required: !this.isEmployee,
            valid_cityState: true,
          },
          MembershipCrmCallerInfo_stateDropDown_state: {
            required: !this.isEmployee,
            notEqual: 'NO_STATE_TYPE_SELECTED',
            valid_cityState: true,
          },
          MembershipCrmCallerInfo_email: {
            singleemail: true,
          },
          MembershipCrmCallerInfo_phone: {
            phone: true,
            required: !this.isEmployee,
          },
          MembershipCrmCallerInfo_mobile: {
            phone: true,
          },
          MembershipCrmCallerInfo_dobEditMonth: {
            required: false,
            dob: true,
          },
          MembershipCrmCallerInfo_dobEditDay: {
            required: false,
            dob: true,
          },
          MembershipCrmCallerInfo_dobEditYear: {
            required: false,
            dob: true,
          },
        },
        messages: {
          MembershipCrmCallerInfo_addressLine1: {
            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
            required: messages.ERR_INVALID_STREET_REQUIRED,
            valid_address: messages.ERR_INVALID_ADDRESS,
          },
          MembershipCrmCallerInfo_addressLine2: {
            maxlength: messages.ERR_INVALID_STREETADDRESS_LENGTH,
            valid_address: messages.ERR_INVALID_ADDRESS,
          },
          MembershipCrmCallerInfo_zipCode: {
            required: messages.ERR_ENTER_ZIPCODE_NEW,
            postalCode: messages.ERR_ENTER_ZIPCODE,
            minlength: messages.ERR_VALID_ZIPCODE,
          },
          MembershipCrmCallerInfo_city: {
            required: messages.ERR_INVALID_CITY_REQUIRED,
            valid_cityState: messages.ERR_INVALID_CITY_NAME,
          },
          MembershipCrmCallerInfo_stateDropDown_state: {
            required: messages.ERR_INVALID_STATE_NAME,
            notEqual: messages.ERR_INVALID_STATE_NAME,
            valid_cityState: messages.ERR_INVALID_STATE_NAME,
          },
          MembershipCrmCallerInfo_email: {
            singleemail: messages.ERR_INVALID_EMAIL_ADDRESS,
          },
          MembershipCrmCallerInfo_phone: {
            phone: messages.ERR_INVALID_PHONE1,
            required: messages.ERR_INVALID_PHONE1,
          },
          MembershipCrmCallerInfo_mobile: {
            phone: messages.ERR_INVALID_PHONE1,
          },
        },
        submitHandler: (form) => {
          if (AccountDetails.needsVerification()) {
            membershipHelper
              // Execute address verification on the primary information address.
              .verifyAddresses({
                form: '#primary-information-update',
                primary: membershipHelper.primaryInformationSelectors,
              })
              // Invoke the address verification modal
              .then((verifyResponse) => membershipHelper.invokeMultiAVS(verifyResponse, AccountDetails.updatePrimaryInformation.bind(AccountDetails)))
              // If the service fails, still submit the form.
              .fail(AccountDetails.updatePrimaryInformation.bind(AccountDetails));
          } else {
            // If we didn't edit the address fields, we dont need the verification
            // service
            AccountDetails.updatePrimaryInformation();
          }
        },
        invalidHandler: (event, validator) => {
          (validator.errorList || []).forEach((errorObj) => {
            let $updateContainer = $(errorObj.element).parents('div[id*=\'update-container\']');
            if ($updateContainer.hasClass('hide')) {
              let $container = $('.' + $updateContainer.data('parent'));
              $container.find('a').trigger('click');
            }
          });
        },
      });
    },
    /**
     * This is the form handler for the Account Manager form (
     * form#account-manager-form).
     * @return {void}
     */
    accountManagerFormHandler: function() {
      membershipHelper.addValidationMethods($('.account-manager-form'));
      $('.account-manager-form').validate({
        rules: {
          member_firstname: {
        	required: true,
        	firstNameValidation: true,
          },	
          member_lastname: {
            required: true,
            lastNameValidation: true,
          },
          member_number: {
            required: true,
            notEqual: this.membershipData.caller.cardNumber.value,
          },
        },
        messages: {
          member_firstname: {
        	required: messages.ERR_INVALID_FNAME_REQUIRED,
        	firstNameValidation: messages.ERR_INVALID_FNAME, 
          },
          member_lastname: {
            required: messages.ERR_INVALID_LNAME_REQUIRED,
            lastNameValidation: messages.ERR_INVALID_LNAME,
          },
          member_number: {
            required: messages.ERR_INVALID_MEMBERSHIP_NO,
            notEqual: messages.ERR_INVALID_MEMBERSHIP_NO,
          },
        },
        submitHandler: (form) => {
          // Clear some state if the previous operation was remove.
          $(form).find('[name=remove_member]').val('');
          this.accountManagerCRUD.call(form, 'add');
        },
      });
    },
    /**
     * This is the form handler for the Household form (
     * form#household-form-details).
     * @return {void}
     */
    householdFormHandler: function() {
      membershipHelper.addValidationMethods($('#household-form-details'));
      let rules = {};
      membershipHelper.addHouseholdRules(rules, true);
      let messages = membershipHelper.goldstar.messages();
      $('#household-form-details').validate({
        rules: rules,
        messages: messages,
        submitHandler: (form) => {
          let requestData = AccountDetails.getData(form);
          // Transform this array to an object so that it can be translated..
          requestData = COSTCO.util.objectifyArray(requestData);
          // Translate the request properties for the backend to properly read.
          requestData = membershipHelper.transformAffiliateHouseholdInputNames(requestData);
          const dayIsOptional = $('#dobYearMonthMandatoryFlag').val()==='true';
          if(dayIsOptional) {
              //dobday is optional, if empty default it to "1"
              if (!requestData.day) {
            	  requestData.day="1";
              }
          }
          requestData.authToken = COSTCO.Checkout.getAuthToken();
          COSTCO.util.ajax({
            url: '/MemberHouseholdAddCmd',
            type: 'POST',
            data: requestData,
          }).done(COSTCO.util.safe(function(response, textStatus, jqXHR) {
            let data = JSON.parse(response);
            if (!AccountDetails.hasError(data)) {
              AccountDetails.successHandler(data);
            }
          }), 'COSTCO.AccountDetails.householdFormHandler').fail(AccountDetails.failHandler);
        },
      });
    },
    /**
     * This is the form handler for the Employee Add On form (
     * form#employee-addon-form).
     * @return {void}
     */
    employeeAddOnFormHandler: function() {
      if (!this.isEmployee) return;
      let rules = membershipHelper.goldstar.rules;
      let messages = membershipHelper.goldstar.messages();
      membershipHelper.addValidationMethods($('#employee-addon-form'));
      $('#employee-addon-form').validate({
        rules: rules,
        messages: messages,
        submitHandler: (form) => {
          membershipHelper
            // Execute address verification on the primary information address.
            .verifyAddresses({
              form: '#employee-addon-form',
              primary: membershipHelper.employeeAddOnSelectors,
            })
            // Invoke the address verification modal
            .then((verifyResponse) => membershipHelper.invokeMultiAVS(verifyResponse, AccountDetails.addEmployeeAddOn.bind(AccountDetails)))
            // If the service fails, still submit the form.
            .fail(AccountDetails.addEmployeeAddOn.bind(AccountDetails));
        },
      });
    },
    /**
     * A generic error handler that displays "Unexpected Error" at the top
     * of the page. Maybe the response from the server is 500, etc.
     * @param  {[type]} jqXHR       [description]
     * @param  {[type]} textStatus  [description]
     * @param  {[type]} errorThrown [description]
     * @return {void}
     */
    failHandler: function(jqXHR, textStatus, errorThrown) {
      $('.order-ajax').removeClass('ajax-busy');
      membershipHelper.handleErrors({
        error: true,
        errorMessages: ['Unexpected Error'],
      });
    },
    /**
     * Update the Capp json and refresh the page.
     * @param  {object} data The response data returned from the server
     * @return {void}
     */
    successHandler: function(data) {
      if (typeof data.caller !== 'undefined') {
        COSTCO.util.safe(COSTCO.util.updateCappJson)(data.caller);
        COSTCO.util.processCappLogic();
      }
      let querystring = {};
      querystring[data.genericMessage ? 'infoUpdateSuccessGeneric' : 'infoUpdateSuccess'] = true;
      // Refresh with parameter.
      window.location.href = COSTCO.util.makeUrl('/AccountInformationView', querystring);
    },
    /**
     * Gets an account manager from the CRM caller using a membership num.
     * @param  {number} membershipNumber The membership number of the account
     *  manager we're after
     * @return {object}                  The object representing the account manager
     */
    getAccountManager: function(membershipNumber) {
      let accountManagerObj = {};
      (this.membershipData.caller.adminAssigned || []).forEach((obj) => {
        if (membershipNumber == obj.adminCardNumber) {
          accountManagerObj = obj;
          return;
        }
      });
      return accountManagerObj;
    },
    /**
     * The onchange handler for the multi membership selector for verified
     * memberships that are an admin of at least one other account. JSP is
     * MultiMembership.jsp
     * @return {void}
     */
    multiMembershipHandler: function() {
      $.cookie('CRM_ADMIN_OVERRIDE', null, {
        path: '/',
      });
      COSTCO.util.safe(() => {
        let theSelected = (memObj) => {
        return memObj.cardNumber === $(this).data('membership-number').toString()
        && memObj.adminRole === $(this).data('membership-adminrole') 
        && memObj.adminType === $(this).data('membership-admintype');
      };
      
      selectedMembership = AccountDetails.membershipData.caller.adminList.find(theSelected);
        $.cookie('CRM_ADMIN_OVERRIDE', JSON.stringify(selectedMembership));
        location.reload();
      })();
    },
    /**
     * Invokes the "Remove Account Manager" modal.
     * @param  {number} membershipNumber The account manager card number
     * @return {void}
     */
    removeAccountManager: function(membershipNumber) {
      let u = COSTCO.util;
      let accountManager = AccountDetails.getAccountManager(membershipNumber);
      let modalBody = u.tmpl('tmpl_remove_account_manager', {
        firstName: u.capitalize(accountManager.firstName.toLowerCase()),
        lastName: u.capitalize(accountManager.lastName.toLowerCase()),
      });
      $(this.form).find('[name=remove_member]').val(membershipNumber);
      COSTCO.dialog.modalStack({
        title: messages.ACCOUNTADMIN_REMOVE_PERSON_TITLE,
        body: modalBody,
        primary: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
        secondary: messages.JS_DIALOG_CANCEL,
        primary_event: () => {
          COSTCO.dialog.close();
          let form = $(this).parents('form');
          form.find('[name=remove_member]').val(membershipNumber);
          AccountDetails.accountManagerCRUD.call(form, 'remove');
        },
      });
    },
    /**
     * Invokes the "Remove Household" modal.
     * @return {void}
     */
    removeHousehold: function() {
      let u = COSTCO.util;
      let household = AccountDetails.membershipData.caller.household;
      let modalBody = u.tmpl('tmpl_remove_household', {
        firstName: u.capitalize(household.firstName.value.toLowerCase()),
        lastName: u.capitalize(household.lastName.value.toLowerCase()),
      });
      COSTCO.dialog.modalStack({
        title: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
        body: modalBody,
        primary: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
        secondary: messages.JS_DIALOG_CANCEL,
        primary_event: () => {
          COSTCO.dialog.close();
          COSTCO.util.ajax({
            url: '/MemberHouseholdRemoveCmd',
            type: 'POST',
            data: {
            	'authToken':COSTCO.Checkout.getAuthToken(),
            	'householdNumber': AccountDetails.membershipData.caller.household.cardNumber.value
            },
          }).done(COSTCO.util.safe(function(response, textStatus, jqXHR) {
            let data = JSON.parse(response);
            if (!AccountDetails.hasError(data)) {
              AccountDetails.successHandler(data);
            }
          }), 'COSTCO.AccountDetails.removeHousehold').fail(AccountDetails.failHandler);
        },
      });
    },
    /**
     * Invokes the "Remove Employee Add On" modal.
     * @param  {number} membershipNumber The membershipNumber of the employee to remove
     * @return {void}
     */
    removeEmployeeAddOn: function(membershipNumber) {
      let u = COSTCO.util;
      let addOn = membershipData.caller.employeeAddOn.find((obj) => {
        return obj.cardNumber.value == membershipNumber;
      });
      let modalBody = u.tmpl('tmpl_remove_employeeAddOn', {
        firstName: u.capitalize(addOn.firstName.value.toLowerCase()),
        lastName: u.capitalize(addOn.lastName.value.toLowerCase()),
      });
      COSTCO.dialog.modalStack({
        title: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
        body: modalBody,
        primary: messages.ADDHOUSEHOLD_MEMBERSHIP__Remove_ModalTitle,
        secondary: messages.JS_DIALOG_CANCEL,
        primary_event: () => {
          COSTCO.dialog.close();
          COSTCO.util.ajax({
            url: COSTCO.util.makeUrl('/MemberEmployeeRemoveAddOnCmd', {
              addonCardNumber: membershipNumber,
            }),
            type: 'POST',
          }).done(COSTCO.util.safe(function(response, textStatus, jqXHR) {
            let data = JSON.parse(response);
            if (!AccountDetails.hasError(data)) {
              AccountDetails.successHandler(data);
            }
          }), 'COSTCO.AccountDetails.removeHousehold').fail(AccountDetails.failHandler);
        },
      });
    },
    /**
     * Compare the CRM caller data to the address form fields and see if
     * anything changed.
     * @param  {boolean} businessInfo - true if business Address to be verified, otherwise false
     * @return {boolean}
     */
    needsVerification: function(businessInfo) {
      let needsVerification = false;
      let c = this.membershipData.caller;
      if (c.usage == 'Z030' && c.usageRole != '03') {
        // Employee Primary/Household doesnt need verification. No address.
        // Employee Add On does.
        return needsVerification;
      }
      if (businessInfo === true) {
        c = this.membershipData.caller.businessInfo;
      }
      let inputArr = $('#address-update-container').find(':input').not('input.btn').map(function() {
        return $(this).val();
      }).toArray();
      [
        c.addressLine1.value,
        c.addressLine2.value,
        c.city.value,
        c.state.value,
        c.zip.value,
      ].forEach((elem) => {
        if (inputArr.indexOf(elem) === -1) {
          // A value changed, we need address verification.
          needsVerification = true;
          return;
        }
      });
      // If any of the CRM address values are empty, we need verification
      if (COSTCO.util.any([
          c.addressLine1.value,
          c.city.value,
          c.state.value,
          c.zip.value,
        ], (element) => {
          return !element;
        })) {
        needsVerification = true;
      }
      return needsVerification;
    },
    /**
     * Populates the Membership Address in the Membership Information
     * section using the address object returned from the verification
     * process.
     * @param  {object} addressObj The addressObj returned from verification
     * @return {void}
     */
    populateAddressFields: function(addressObj) {
      $('[name=MembershipCrmCallerInfo_addressLine1]').val(addressObj.line1);
      $('[name=MembershipCrmCallerInfo_addressLine2]').val(addressObj.line2);
      $('[name=MembershipCrmCallerInfo_zipCode]').val(addressObj.zip);
      $('[name=MembershipCrmCallerInfo_city]').val(addressObj.city);
      $('[name=MembershipCrmCallerInfo_stateDropDown_state]').val(addressObj.state);
    },
    /**
     * Populates the Employee Add On Address in the Additional People
     * section using the address object returned from the verification
     * process.
     * @param  {object} addressObj The addressObj returned from verification
     * @return {void}
     */
    populateEmployeeAddressFields: function(addressObj) {
      $('[name=employeeAddon_addressLine1]').val(addressObj.line1);
      $('[name=employeeAddon_addressLine2]').val(addressObj.line2);
      $('[name=employeeAddon_zip]').val(addressObj.zip);
      $('[name=employeeAddon_city]').val(addressObj.city);
      $('[name=employeeAddon_state]').val(addressObj.state);
    },
    /**
     *
     * @deprecated We are now using ajax modular to submit membership information form via AccountDetails.ajaxUpdatePrimaryInformation(data);
     *
     * Makes the actual ajax request to update the primary information, returns
     * a promise if it doesn't refresh the page in the case where we want to
     * do something additional after this operation.
     * @param  {[type]} addresses [description]
     * @return {jQuery.Deferred} Use to chain thenables.
     */
    updatePrimaryInformation: function(addresses) {
      if (addresses && addresses.length > 0) {
        // Case where we returned from the verification modal with the
        // address the user selected. Populate the address inputs so
        // they can be serialized as part of the subsequent request to
        // MemberPrimaryInformationUpdateCmd
        this.populateAddressFields(addresses[0]); // We'll only have one returned.
      }
      return COSTCO.util.ajax({
        url: '/MemberPrimaryInformationUpdateCmd',
        type: 'POST',
        data: AccountDetails.getData('#primary-information-update'),
      }).then(COSTCO.util.safe(function(response, textStatus, jqXHR) {
        let data = JSON.parse(response);
        AccountDetails.membershipData = data;
        if (!AccountDetails.hasError(data)) {
          AccountDetails.successHandler(data);
        }
      }), 'COSTCO.AccountDetails.updatePrimaryInformation').fail(AccountDetails.failHandler);
    },
    /**
     * Makes the actual ajax request to add an Employee Add On, returns
     * a promise if it doesn't refresh the page in the case where we want to
     * do something additional after this operation.
     * @param  {object} addresses addresses returned from the AVS.
     * @return {jQuery.Deferred} Use to chain thenables.
     */
    addEmployeeAddOn: function(addresses) {
      if (addresses && addresses.length > 0) {
        // Case where we returned from the verification modal with the
        // address the user selected. Populate the address inputs so
        // they can be serialized as part of the subsequent request to
        // MemberPrimaryInformationUpdateCmd
        this.populateEmployeeAddressFields(addresses[0]); // We'll only have one returned.
      }
      return COSTCO.util.ajax({
        url: '/MemberEmployeeAddCmd',
        type: 'POST',
        data: AccountDetails.getData('#employee-addon-form'),
      }).then(COSTCO.util.safe(function(response, textStatus, jqXHR) {
        let data = JSON.parse(response);
        AccountDetails.membershipData = data;
        if (!AccountDetails.hasError(data)) {
          AccountDetails.successHandler(data);
        }
      }), 'COSTCO.AccountDetails.addEmployee').fail(AccountDetails.failHandler);
    },
    /**
     * Makes the actual ajax request to update the membership number, returns
     * a promise if it doesn't refresh the page in the case where we want to
     * do something additional after this operation.
     * @return {jQuery.Deferred} Use to chain thenables.
     */
    updateMembershipNumber: function() {
      return COSTCO.util.ajax({
        url: '/MemberMembershipInformationUpdateCmd',
        type: 'POST',
        data: $('#membership-number-form').serializeArray(),
      }).then(COSTCO.util.safe(function(response, textStatus, jqXHR) {
        let data = JSON.parse(response);
        AccountDetails.membershipData = data;
        if (!AccountDetails.hasError(data)) {
          if (location.search.includes('PharmacyManagePatientProfileCmd')) {
            // Redirect to pharmacy
            window.location.href = 'Pharmacy/patient-profile?selectedTab=account_and_patient_info&SuccessMessageKey=true';
          } else if (typeof redirectAfterMemNumUpdate !== 'undefined') {
            // Redirect to product page referrer. (backwards capability)
            // redriectAfterMemNumUpdate defined in AccountDetails_Data.jsp
            window.location.href = redirectAfterMemNumUpdate;
          } else {
            AccountDetails.successHandler(data);
          }
        }
      }), 'COSTCO.AccountDetails.updateMembershipNumber').fail(AccountDetails.failHandler);
    },
    /**
     * Makes the actual ajax request to CRUD the account manager.
     * @param  {string} operation Add/remove
     * @return {void}
     */
    accountManagerCRUD: function(operation) {
      $(this).find('input[name=operation]').val(operation);
      return COSTCO.util.ajax({
        url: '/MemberAccountAdminCmd',
        type: 'POST',
        data: AccountDetails.getData(this),
      }).then(COSTCO.util.safe(function(response, textStatus, jqXHR) {
        let data = JSON.parse(response);
        if (!AccountDetails.hasError(data)) {
          AccountDetails.successHandler(data);
        }
      }), 'COSTCO.AccountDetails.accountManagerFormHandler').fail(AccountDetails.failHandler);
    },

    /**
     * The wrapper for the member verification modal. Pass the membership num.
     * @return {void}
     */
    memberVerification: function() {
      
      // for debug trying to find scenario when membership does not pre-prop
      // alert('#update-membership is: '+ $('#update-membership').val());
      // alert('#membershipId is: '+ $('#membershipId').val());
      // alert('#membershipNumber is: '+ $('#membershipNumber').val());
      
      let membershipButton = $("input[automation-id='verifyMembershipButton");
      if (typeof(membershipButton) != 'undefined' && membershipButton != null) {
    	  membershipButton.attr("data-bi-tc", "ui:Account Details | Verify Membership");
      }
	
      let membershipNumber = $('#update-membership').val() || $('#membershipId').val() || $('#membershipNumber').val() || $('#memberCardNumber').val();
      var reactAccountDetailsFlag = $('#accountDetailsReactEnabled').val();
      if(reactAccountDetailsFlag === 'true' && typeof membershipNumber === "undefined"){
          membershipNumber = reactObj.accountDetails.membershipId; 
      }
      if (typeof wcs.storeId !== "undefined" && wcs.storeId === "10302") {
        secureKeyMemberVerification.openMembershipVerificationDialog(membershipNumber);
      } else {
        memberVerification.openMembershipVerificationDialog(membershipNumber);
      }
    },
    /**
	 * JQuery Ajax service
	 */
	callAjaxService: function(httpMethod, serviceUrl, headers, data) {
		
		if((undefined == serviceUrl || null == serviceUrl || serviceUrl == "") 
				|| (undefined == httpMethod  || null == httpMethod || httpMethod == ""))
			return null;
		
		let serviceResponse = null;
		$.ajax({
	        url: serviceUrl,
	        type: httpMethod,
	        dataType: 'json',
	        global: false,
            async: false,
            contentType: 'application/json',
	        data: (undefined != data && "" != data) ? JSON.stringify(data) : {},
	        headers: (undefined != headers && "" != headers) ? headers : {},
	        success: function (response) {
	        	console.log('response: '+response);
	        	serviceResponse = response;
            },
            error: function (errorResponse) {
                console.log(errorResponse);
            }, 
            complete: function(request, status){
            	console.log('complete: '+status);
            }
	    });
		
		return serviceResponse;
	},
	/**
	 * Method to get user JWT token
	 */
	getUserToken: function() {
		let userIdToken = null;
		
		let tokenResponse = COSTCO.AccountDetails.callAjaxService('GET', '/gettoken', null, null);
		
		if(null != tokenResponse && tokenResponse.has_logged_in && undefined != tokenResponse.id_token) {
    		userIdToken = tokenResponse.id_token;
    	} 
		if(userIdToken == null){
			return null;
		} else { 
			return userIdToken;
		}
    },
    getSubFromJwt: function () {
    	let jwt = COSTCO.AccountDetails.getUserToken();
    	console.log(jwt);
    	let expired = true;
  	    let jwtPayload = JSON.parse(atob(jwt.split('.')[1]));
  	    console.log('Sub : '+jwtPayload.sub);
  	    return jwtPayload.sub;
     },
     getEmailFromJwt: function () {
     	let jwt = COSTCO.AccountDetails.getUserToken();
     	console.log(jwt);
     	let expired = true;
   	    let jwtPayload = JSON.parse(atob(jwt.split('.')[1]));
   	    console.log('Email : '+jwtPayload.email);
   	    return jwtPayload.email;
      },    
    /**
     * Interrogates the response data from the server. If theres an error,
     * display it at the top of the UI and return true, else return false.
     * @param  {object} data The response from the server
     * @return {boolean}     Was there an error?
     */
    hasError: function(data) {
      let hasError = false;
      if (data.errorMessage && data.errorMessage.length > 0) {
        membershipHelper.handleErrors({
          error: 'true',
          errorMessages: [data.errorMessage],
        });
        hasError = true;
      } else if (data.systemMessage && data.systemMessage.length > 0) {
        membershipHelper.handleErrors({
          error: 'true',
          errorMessages: [data.systemMessage],
        });
        hasError = true;
      } else if (data.errorMessages && data.errorMessages.length > 0) {
    	  if ($('input[name="gmpFeatureEnabled"]').val() == 'true' || $('input[name="gmpCookie"]').val() == 'true') {
              if (data.errorMessages[0] == 'ERR_GMP_USER_ALREADY_REMOVED') {
            	  data.errorMessages[0] = $('.gmpUserDeletedMessageText').text();
              }
    	  }
        membershipHelper.handleErrors(data);
        hasError = true;
      }
      return hasError;
    },
    /**
     * Serializes the given form as an array of objects with each of the property
     * values trimmed of whitespace. Used to transmit well formed data to backend.
     * @param  {jQuery.Object} form The form to serialize into array of objects
     * @return {array}      The array of objects.
     */
    getData: function(form) {
      return $(form).serializeArray().map((obj) => {
        // Lets make sure theres no trailing whitespace.
        obj.value = $.trim(obj.value);
        return obj;
      });
    },
    /**
     * Function that is used for verification modal in case of DMC
     * It redirects user to join Costco page
     * @return {void}
     */
    buyMembership: function() {
        window.location = '/join-costco.html?COSTID=Header_Membership_TOP';
      },
      
    /** Membership Number Info **/
	membershipNumberInfo : function(){
	    	var modalOptions = {
	    	        title: messages.RWD_MEMBERSHIP_NUMBER,
	    	        body: COSTCO.util.tmpl('tmpl_membership_num_modal'),
	    	        primary: messages.CLOSE,
	    	        primary_button_fullspan:false,
	        		primary_event: function() {
	        			COSTCO.dialog.close();
	        		}
	    	      }
	    	COSTCO.dialog.showAndHideModal(modalOptions);
	}, 
  };
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = {};
  }
  window.COSTCO.AccountDetails = AccountDetails;
  return AccountDetails;
});



// WEBPACK FOOTER //
// ./js/account/account-details.js